import {useState} from "react";
import {Button, Text} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import ThreadButtonMenu from "./ThreadButtonMenu";
import IconDots from "../../../../assets/dots.svg?react";
import classes from "./ThreadButton.module.css";

interface Props {
    id: string;
    name: string;
    onClick: (id: string) => void;
    isSelected: boolean;
    isLoading: boolean;
}

export const ThreadButton: React.FC<Props> = ({
    id,
    name,
    onClick,
    isSelected,
    isLoading,
}) => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/chat/${id}`);
        onClick(id);
    };

    return (
        <Button
            className={`${classes.button} ${menuOpen ? classes.expanded : ""} ${
                isSelected ? classes.selected : ""
            } ${isLoading ? classes.loading : ""}`}
            classNames={{section: classes.section, label: classes.label}}
            variant="subtle"
            size="xs"
            px="xs"
            rightSection={
                <ThreadButtonMenu
                    id={id}
                    onOpen={() => setMenuOpen(true)}
                    onClose={() => setMenuOpen(false)}
                >
                    <div onClick={(e) => e.stopPropagation()}>
                        <IconDots style={{color: "white"}} width={16} />
                    </div>
                </ThreadButtonMenu>
            }
            onClick={handleClick}
        >
            <Text className={classes.text} fz="sm">
                {name}
            </Text>
        </Button>
    );
};
